import { Reveal, Eyebrow } from "./Reveal";

export default function Vision() {
  return (
    <section id="vision" className="py-24 lg:py-32 bg-[#F9FAFB]" data-testid="vision-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-6">
            <Reveal>
              <Eyebrow number="09" label="Our Vision" />
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-[#111827]">
                Technology That Preserves{" "}
                <span className="font-serif-italic text-[#7F9F43]">Dignity.</span>
              </h2>
              <div className="mt-8 space-y-5 text-gray-500 leading-relaxed text-base md:text-lg max-w-xl">
                <p>
                  Living with cognitive decline should never mean losing dignity, confidence, or
                  independence.
                </p>
                <p>
                  We envision a future where artificial intelligence quietly supports people in
                  their everyday lives — helping them remain connected, reassured, and empowered.
                </p>
                <p className="text-[#111827] text-xl font-serif-italic">
                  Romii is only the beginning.
                </p>
                <p>
                  Our long-term vision is to build an ecosystem of intelligent assistive
                  technologies that redefine cognitive care and improve quality of life for
                  millions of people around the world.
                </p>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-5 lg:col-start-8">
            <Reveal delay={0.15}>
              <div className="rounded-3xl overflow-hidden card-soft relative">
                <img
                  src="/assets/romii-neck.jpg"
                  alt="Romii worn as a pendant around the neck"
                  className="w-full h-[420px] lg:h-[520px] object-cover hover:scale-[1.03] transition-transform duration-700"
                  data-testid="vision-product-image"
                />
                <p className="absolute bottom-4 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full backdrop-blur-xl bg-white/75 px-4 py-2 text-[10px] tracking-[0.15em] uppercase text-gray-500 font-semibold">
                  Concept Illustration • Final design may vary
                </p>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
